import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { getCoords, getViewport, scrollPosition } from "../utils/utils";
import normalizeWheel from "normalize-wheel";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.detail = false
    if(this.ref.detail != null) {
      this.DOM.detail = this.ref.detail[0];
    }
    this.fnResize = this.calculate.bind(this);
    this.RAF = false;

    gsap.delayedCall(0.5, () => {});
    this.calculate();
    this.wheelDetection();
    this.watcher();

    Channels.on("window::smartresize", this.fnResize);
  }

  calculate() {
    if (Env.mobileCSS == false && this.DOM.detail != false) {
      gsap.delayedCall(0.25, () => {
        gsap.set(this.DOM.detail, { paddingTop: 0 });
        const coord = getCoords(this.DOM.detail);
        const viewport = getViewport();

        let setPaddingTop = (viewport.height - coord.height) / 2;
        gsap.set(this.DOM.detail, { bottom: setPaddingTop });
      });
    }
  }

  watcher() {
    this.RAF = requestAnimationFrame(() => {
      if (this.DOM.detail != false && getCoords(this.DOM.detail).y < 100) {
        Env.$html.classList.add("force-menu-revealing");
      } else {
        Env.$html.classList.remove("force-menu-revealing");
      }

      this.watcher();
    });
  }

  wheelDetection() {
    document.addEventListener("mousewheel", function (event) {
      const normalized = normalizeWheel(event);
      const blockMaxHeight = parseInt(
        getComputedStyle(event.target).getPropertyValue("max-height")
      );
      const blockHeight = getCoords(event.target).height;
      // console.log(blockMaxHeight, blockHeight);
      // console.log(event.target.scrollWidth > event.target.clientWidth);
      const scrollPos = scrollPosition();
      if (event.target.getAttribute("data-lenis-prevent") != null) {
        if (
          blockHeight < blockMaxHeight &&
          normalized.pixelY < 0 &&
          scrollPos.scrollY == 0
        ) {
          Channels.emit("accordions::close");
        }
        // Channels.emit("accordions::close");
      } else {
        if (normalized.pixelY < 0 && scrollPos.scrollY == 0) {
          Channels.emit("accordions::close");
        }
      }
    });
  }

  unmount() {
    cancelAnimationFrame(this.RAF);
    Channels.removeListener("window::smartresize", this.fnResize);
  }
}
